import React from 'react'
import Responsive from 'react-responsive'

export const Handheld = (props) => <Responsive {...props} maxWidth={991} />
export const Default = (props) => <Responsive {...props} minWidth={992} />
